import { StatisticalAnalysisViewDetailChartFilterAxisXY, StatisticalAnalysisViewDetailChartFilterAxisCombo, StatisticalAnalysisViewDetailChartFilterAxisState, initialStatisticalAnalysisViewDetailChartFilterAxisState } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail-chart-filters-axis/statistical-analysis-view-detail-chart-filters-axis.model'
import { Nullable } from '@/shared/types/app.types'
import { cloneDeep, reject } from 'lodash'
import { Vue, Component, Emit, Prop } from 'vue-property-decorator'

@Component
export default class StatisticalAnalysisViewDetailChartFilterAxis extends Vue {
    @Prop() readonly axisParams!: StatisticalAnalysisViewDetailChartFilterAxisXY;
    @Emit()
    changeAxisYMainCombo(value: Nullable<StatisticalAnalysisViewDetailChartFilterAxisCombo>): Nullable<StatisticalAnalysisViewDetailChartFilterAxisCombo> {
        return value
    }
    @Emit()
    changeAxisXMainCombo(value: Nullable<StatisticalAnalysisViewDetailChartFilterAxisCombo>): Nullable<StatisticalAnalysisViewDetailChartFilterAxisCombo> {
        return value
    }
    @Emit()
    changeAxisXAssociatedCombo(value: Nullable<StatisticalAnalysisViewDetailChartFilterAxisCombo>): Nullable<StatisticalAnalysisViewDetailChartFilterAxisCombo> {
        return value
    }

    state:StatisticalAnalysisViewDetailChartFilterAxisState
    constructor() {
        super()
        this.state = initialStatisticalAnalysisViewDetailChartFilterAxisState()
    }

    get isLoading(): boolean {
        return this.state.loading
    }

    get yAxisVisible(): boolean {
        return this.state.yAxis.show
    }

    get xAxisVisible(): boolean {
        return this.state.xAxis.show
    }

    get xAxisMainComboSelected(): boolean {
        return !!this.state.xAxis.mainCombo?.selected!
    }

    created() {
        this.$eventHub.$on('statistical-loading', this._onStatisticalLoadingGridTable)
        this.state = {
            ...this.state,
            xAxis: cloneDeep(this.axisParams.xAxis),
            yAxis: cloneDeep(this.axisParams.yAxis)
        }
        this._updateAssociatedCombo()
    }

    beforeDestroy() {
        this.$eventHub.$off('statistical-loading', this._onStatisticalLoadingGridTable)
    }

    onChangeYMainCombo(value: StatisticalAnalysisViewDetailChartFilterAxisCombo): void {
        this.changeAxisYMainCombo(value)
    }

    onChangeXMainCombo(value: Nullable<StatisticalAnalysisViewDetailChartFilterAxisCombo>): void {
        if (value) {
            this.changeAxisXMainCombo(value)
            this._updateAssociatedCombo(true)
        } else {
            this._resetAssociatedCombo()
            this.changeAxisXAssociatedCombo(null)
        }
    }

    onChangeXAssociatedCombo(value: Nullable<StatisticalAnalysisViewDetailChartFilterAxisCombo>): void {
        this.changeAxisXAssociatedCombo(value)
    }

    private _updateAssociatedCombo(resetAssociated: boolean = false): void {
        const auxMainCombo = cloneDeep(this.state.xAxis.mainCombo?.list)
        const listAssociatedCombo = reject(auxMainCombo, ['id', this.state.xAxis.mainCombo?.selected?.id!])
        this.state = {
            ...this.state,
            xAxis: {
                show: this.state.xAxis.show,
                mainCombo: {
                    list: this.state.xAxis.mainCombo?.list!,
                    selected: this.state.xAxis.mainCombo?.selected
                },
                associatedCombo: {
                    list: listAssociatedCombo,
                    selected: resetAssociated ? null : this.axisParams.xAxis.associatedCombo?.selected
                }
            }
        }
    }

    private _resetAssociatedCombo(): void {
        this.state = {
            ...this.state,
            xAxis: {
                ...this.state.xAxis,
                associatedCombo: cloneDeep(this.axisParams.xAxis.associatedCombo)
            }
        }
    }

    private _onStatisticalLoadingGridTable(value: boolean): void {
        this.state.loading = value
    }
}
